import { render } from "./GzhFieldHelp.vue?vue&type=template&id=0f3b3dbb&scoped=true"
import script from "./GzhFieldHelp.vue?vue&type=script&lang=js"
export * from "./GzhFieldHelp.vue?vue&type=script&lang=js"

import "./GzhFieldHelp.vue?vue&type=style&index=0&id=0f3b3dbb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3b3dbb"]])

export default __exports__